<div class="p-grid">
  <div class="p-col-12 p-xl-2">
    <p-card header="Teardowns">
      <div class="form-group" *ngIf="teardownItem; else tdwnFiller" [formGroup]="teardownItem" style="margin-bottom: 1rem;">
        <label for="teardowns">Teardowns</label>
        <input type="number" pInputText id="teardowns" required name="teardowns" class="form-control" formControlName="teardowns"/>
        <error-block [field]="teardownItem.controls.teardowns" [messages]="{
          required: 'Teardowns is required.'
        }"></error-block>
      </div>
      <ng-template #tdwnFiller>
        <div class="form-group" style="margin-bottom: 1rem;">
          <label for="teardowns">Teardowns</label>
          <input type="number" pInputText id="teardowns" value="0" disabled />
        </div>
      </ng-template>
    </p-card>
  </div>
  <div class="p-col-12 p-md-6 p-xl-5">
    <p-card header="Identified Scrap">
      <p-table [value]="identifiedScrapItems" dataKey="controls.id.value" [autoLayout]="true" rowGroupMode="subheader" [rowTrackBy]="rowTrackBy">
        <ng-template pTemplate="header">
          <tr>
            <th>Product<span class="required">*</span></th>
            <th>Pieces<span class="required">*</span></th>
            <th>Delete</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-ri="rowIndex">
          <tr [formGroup]="rowData">
            <td>
              <p-dropdown
                [options]="identifiedScrapProducts"
                formControlName="productId"
                appendTo="body"
                name="product"
                [required]
                [filter]="true"
                [editable]="false"
                [resetFilterOnHide]="true">
              </p-dropdown>
              <error-block [field]="rowData.controls.productId" [messages]="{
                required: 'Product is required.'
              }">
              </error-block>
            </td>
            <td>
              <input pInputText type="number"
                     formControlName="teardowns"
                     style="width:100%"
                     name="teardowns"
                     required
                     lib-numeric />
              <error-block [field]="rowData.controls.teardowns" [messages]="{
                required: 'Pieces is required.'
              }">
              </error-block>
            </td>
            <td>
              <confirmation-button
                [iconsOnly]="true"
                actionIcon="pi pi-times"
                actionText="Delete"
                confirmIcon="pi pi-times"
                confirmText="Delete"
                cancelIcon="pi pi-minus-circle"
                cancelText="Cancel"
                [disabled]="rowData.disabled"
                (actionConfirmed)="deleteIdScrapItem(rowData)">
              </confirmation-button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="3" class="centered">
              No data available
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer" let-rowData>
          <tr [formGroup]="addIdScrapForm">
            <td>
              <p-dropdown [options]="identifiedScrapProducts" [required] appendTo="body"
                          placeholder="-- Select Product --" formControlName="productId"
                          class="form-control" name="product" [filter]="true" [editable]="false" [resetFilterOnHide]="true">
              </p-dropdown>
              <error-block [field]="addIdScrapForm.controls.productId" [messages]="{
                required: 'Product is required.'
              }">
              </error-block>
            </td>
            <td>
              <input type="number" lib-numeric pInputText required name="teardowns" class="form-control" formControlName="teardowns"/>
              <error-block [field]="addIdScrapForm.controls.teardowns" [messages]="{
                required: 'Pieces is required.'
              }">
              </error-block>
            </td>
            <td>
              <button type="button" pButton
                      icon="pi pi-plus"
                      iconPos="left"
                      (click)="addIdScrap();"
                      label="Add"
                      [disabled]="addIdScrapForm.disabled"
                      [ngClass]="{ 'p-state-disabled': !addIdScrapForm.valid }"></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  </div>
  <div class="p-col-12 p-md-6 p-xl-5">
    <p-card header="Pallets Scrapped">
      <p-table [value]="scrapItems" dataKey="controls.id.value" [autoLayout]="true" rowGroupMode="subheader" [rowTrackBy]="rowTrackBy">
        <ng-template pTemplate="header">
          <tr>
            <th>Product<span class="required">*</span></th>
            <th>Pieces<span class="required">*</span></th>
            <th>Delete</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-ri="rowIndex">
          <tr [formGroup]="rowData">
            <td>
              <p-dropdown
                [options]="scrapProducts"
                formControlName="productId"
                appendTo="body"
                name="product"
                [required]
                [filter]="true"
                [editable]="false"
                [resetFilterOnHide]="true">
              </p-dropdown>
              <error-block [field]="rowData.controls.productId" [messages]="{
                required: 'Product is required.'
              }">
              </error-block>
            </td>
            <td>
              <input pInputText type="number"
                formControlName="teardowns"
                style="width:100%"
                name="teardowns"
                required
                lib-numeric />
              <error-block [field]="rowData.controls.teardowns" [messages]="{
                required: 'Pieces is required.'
              }">
              </error-block>
            </td>
            <td>
              <confirmation-button
                [iconsOnly]="true"
                actionIcon="pi pi-times"
                actionText="Delete"
                confirmIcon="pi pi-times"
                confirmText="Delete"
                cancelIcon="pi pi-minus-circle"
                cancelText="Cancel"
                [disabled]="rowData.disabled"
                (actionConfirmed)="deleteScrapItem(rowData)">
              </confirmation-button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="3" class="centered">
              No data available
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer" let-rowData>
          <tr [formGroup]="addScrapForm">
            <td>
              <p-dropdown [options]="scrapProducts" [required] appendTo="body"
                  placeholder="-- Select Product --" formControlName="productId"
                  class="form-control" name="product" [filter]="true" [editable]="false" [resetFilterOnHide]="true">
              </p-dropdown>
              <error-block [field]="addScrapForm.controls.productId" [messages]="{
                required: 'Product is required.'
              }">
              </error-block>
            </td>
            <td>
              <input type="number" lib-numeric pInputText required name="teardowns" class="form-control" formControlName="teardowns"/>
              <error-block [field]="addScrapForm.controls.teardowns" [messages]="{
                required: 'Pieces is required.'
              }">
              </error-block>
            </td>
            <td>
              <button type="button" pButton
                icon="pi pi-plus"
                iconPos="left"
                (click)="addScrap();"
                label="Add"
                [disabled]="addScrapForm.disabled"
                [ngClass]="{ 'p-state-disabled': !addScrapForm.valid }"></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  </div>
</div>

